import { render, staticRenderFns } from "./PriceOnlineSwitch.vue?vue&type=template&id=4b491df2&scoped=true&"
import script from "./PriceOnlineSwitch.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceOnlineSwitch.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceOnlineSwitch.vue?vue&type=style&index=0&id=4b491df2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b491df2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b491df2')) {
      api.createRecord('4b491df2', component.options)
    } else {
      api.reload('4b491df2', component.options)
    }
    module.hot.accept("./PriceOnlineSwitch.vue?vue&type=template&id=4b491df2&scoped=true&", function () {
      api.rerender('4b491df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceToolbar/PriceOnlineSwitch.vue"
export default component.exports